<template>
  <div>
    <div class="form">
      <el-radio-group v-model="dateType">
        <el-radio-button label="day" >日</el-radio-button>
        <el-radio-button label="week">周</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-model="dateModels[dateType]"
        v-bind="pickerProps"
        style="min-width: 240px;"
      />
    </div>

    <el-checkbox-group size="small" v-model="checkbox">
      <el-checkbox-button
        v-for="(name, index) of plugins"
        :key="index"
        :label="name"
      />
    </el-checkbox-group>

    <el-table
      :data="dataSource"
      size="small"
      v-loading="loading"
    >
      <el-table-column label="日期" align="right" prop="date">
          <template slot-scope="{row}">{{ row.date | formatDate('M月D日') }}</template>

      </el-table-column>
      <el-table-column label="余额购买" align="center">
        <el-table-column label="笔数" align="center" prop="count">
          <template slot-scope="{row}">
            <RecordDiff :row="row" prop="count"></RecordDiff>
          </template>
        </el-table-column>
        <el-table-column label="金额" align="center" prop="amount">
          <template slot-scope="{row}">{{ row.amount || 0 }}</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="赠金购买" align="center">
        <el-table-column label="笔数" align="center" prop="money_gift_count">
          <template slot-scope="{row}">
            <RecordDiff :row="row" prop="money_gift_count"></RecordDiff>
          </template>
        </el-table-column>
        <el-table-column label="金额" align="center" prop="money_gift">
          <template slot-scope="{row}">{{ row.money_gift || 0 }}</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="总量" align="center">
        <el-table-column label="笔数" align="center" prop="total_count">
          <template slot-scope="{row}">{{ row.total_count || 0 }}</template>
        </el-table-column>
        <el-table-column label="金额" align="center" prop="total_money">
          <template slot-scope="{row}">{{ row.total_money || 0 }}</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="购买人数" align="center" prop="member_count">
          <template slot-scope="{row}">{{ row.member_count || 0 }}</template>
        </el-table-column>
      <el-table-column label="复购率" align="center" prop="repeat">
          <template slot-scope="{ row }">{{ row.repeat }}%</template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>

import admin_product_day_rpt from '@/api/admin_product_day_rpt'
import RecordDiff from './RecordDiff'
import '@/utils/date'
import { formatDate, getMonthRange, getWeekEndDay, getWeekRange, isSameMoment } from '@/utils/date'
import dayjs from 'dayjs'
import admin_product_plug_tongji_list from '@/api/admin_product_plug_tongji_list'
export default {
  name: 'DateTable',

  filters :{
    formatDate,
  },

  components: {
    RecordDiff,
  },

  data: () => ({
    dateType: 'day', // day/week/month
    dateModels: { // date-picker 绑定的时间
      day: new Date(),
      week: new Date(),
      month: new Date(),
    },

    form: {
      day: 0,
      day_end: 0,
      plug: 'all',
    },

    dataCache: {
      day: { day: 0, day_end: 0, plug: '', list: [], loading: false },
      week: { day: 0, day_end: 0, plug: '', list: [], loading: false },
      month: { day: 0, day_end: 0, plug: '', list: [], loading: false },
    },

    plugins: [],
  }),

  computed: {
    checkbox: {
      get() {
        const { plug } = this.form
        if (plug === 'all') {
          return [...this.plugins]
        }
        return this.form.plug.split(',').filter((name) => !!name)
      },

      set(value) {
        if (value.length === this.plugins) {
          this.form.plug = 'all'
        } else {
          this.form.plug = value.join(',')
        }
      },
    },

    date() {
      return this.dateModels[this.dateType]
    },
    currentDate() {
      return this.dateModels[this.dateType]
    },

    dataSource() {
      return this.dataCache[this.dateType].list
    },

    loading() {
      return this.dataCache[this.dateType].loading
    },

    pickerProps() {
      const props = {
        day: {},
        week: {
          type: 'week',
          format: getWeekRange(this.date).map((date) => dayjs(date).format('YYYY-MM-DD')).join(' - '),
          firstDayOfWeek: 1,
          pickerOptions: {
            disabledDate: (time) => {
              const isAfter = dayjs(time).isAfter(dayjs(), 'date') // time是否大于今天
              const nowWeek = getWeekEndDay()
              const nextWeek = getWeekEndDay(time)
              if (isAfter && nextWeek > nowWeek) {
                return true
              }
            },
          },
        },
        month: {
          type: 'month',
          format: 'yyyy-MM',
        },
      }
      return {
        placeholder: '选择日期',
        clearable: false,
        pickerOptions: { disabledDate: (time) => dayjs(time).isAfter(dayjs(), 'date') },
        ...props[this.dateType] || {},
      }
    },
  },

  watch: {
    currentDate: {
      immediate: true,
      handler() {
        let dateRange = []
        switch(this.dateType) {
        case 'day': dateRange = [this.currentDate, this.currentDate]; break;
        case 'week': dateRange = getWeekRange(this.currentDate); break;
        case 'month': dateRange = getMonthRange(this.currentDate); break;
        }
        const [day, day_end] = dateRange
        this.form.day = day
        this.form.day_end = day_end
      },
    },


    form: {
      immediate: true,
      deep: true,
      handler() {
        this.loadData()
      },
    },

  },


  methods: {

    sortFn(prop) {
      return (a, b) => {
        return (a[prop] || 0) - (b[prop] || 0)
      }
    },

    async loadData() {
      const { day, day_end, plug } = this.form
      const cache = this.dataCache[this.dateType]

      // 有缓存 不更新
      if (
        isSameMoment(day, cache.day)
         && isSameMoment(day_end, cache.day_end)
         && plug === cache.plug
      ) {
        return
      }

      if (cache.loadData === true) {
        return
      }

      cache.loading = true
      const { data } = await admin_product_day_rpt(this.form)
      const list = data.list || {}
      cache.list = Object.entries(list)
        .map(([date, item]) => ({...item, date: date }))
        .sort((a, b) => {
          a = new Date(a.date.replace(/-/g, '/')).valueOf()
          b = new Date(b.date.replace(/-/g, '/')).valueOf()
          return b - a
        })
      cache.day = day
      cache.day_end = day_end
      cache.plug = plug

      cache.loading = false
    },

    async loadPlugins() {
      const { data } = await admin_product_plug_tongji_list()
      if (data.error_code === 0) {
        this.plugins = data.production_plug_list || []
      }
    },
  },

  mounted() {
    this.loadPlugins()
  },
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 10px;

  .el-radio-group {
    margin-right: 10px;
  }
}

.el-checkbox-group {
  margin-bottom: 7px;
}
.el-checkbox-button {
  margin: 0 3px 3px 0;
  /deep/ .el-checkbox-button__inner {
    border-radius: 4px;
    border-left: 1px solid #dcdfe6;
  }
}
</style>
